<template>
    <div data-toggle="tooltip" :title="text">
        {{ viewText }}
    </div>
</template>

<script>
export default {
    name: "EllipsisText",
    props: {
        text: [String, Number, Boolean],
        maxLength: {
            type: Number,
            default: 50
        }
    },
    computed: {
        overflow() {
            return typeof this.text === 'string' && this.text.length > this.maxLength;
        },
        viewText() {
            let value = this.text;
            if (this.overflow) {
                return value.substring(0, this.maxLength) + '...';
            }
            return value;
        },
    },
    mounted() {
        if (this.overflow) {
            this.$emit('ellipsis');
        }
    }
}
</script>

<style scoped>

</style>
